import StickyContent from '../components/sticky-content';

export default {
  init() {
    const stickyElement = document.querySelector('.c-page__background-image');
    new StickyContent({
      element: stickyElement,
      section: '.c-page--static-scroll',
      debugId: 'sticky bg',
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/templateStaticScroll.js